var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"35","height":"38","fill":"white","key":0}),React.createElement("path",{"d":"M11.5319 1L8.54787 19.2584H12.7606V37H1V19.2584L5.3883 1H11.5319ZM32.7713 1L29.7872 19.2584H34V37H22.2394V19.2584L26.6277 1H32.7713Z","fill":"#102B2D","key":1})]);
}

QuoteInline.defaultProps = {"width":"35","height":"38","viewBox":"0 0 35 38","fill":"none"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
